var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }